import React, { Fragment } from "react";
import Header from "../Components/Layout/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../Components/Layout/Footer";

const TermsConditions = () => {
  return (
    <Fragment>
      <Container  sx={{ py: 4 }}>
        <Typography variant="h3" component="h2" sx={{ textAlign: "center" }}>
          Terms & Conditions
        </Typography>
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          22 March 2020 (Version 1)
        </Typography>
        <Typography>
          These terms and conditions regulate the business relationship between
          you and us. By using our website in any way, or by buying from us, you
          agree to be bound by them. <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          1. Definitions
        </Typography>
        <Typography>
          In this agreement no person under the age of 18 years may purchase
          Goods.
          <ul>
            <li>
              “We” refers to Faam Gallery Ltd, 131 Percy Road, Twickenham,
              Whitton, London, England, United Kingdom, TW2 6HT
            </li>
            <li>
              “You” refers to visitor to our website faamgallery.com or our
              customer
            </li>
            <li>
              “Carrier” means any person or business contracted by us or our
              artists to carry Goods from us to you, whether all or part of the
              distance.
            </li>
            <li>
              “our website” means the entire computing hardware and software
              installation that is or supports our website.
            </li>
            <li>
              “Goods” means any of the Goods we offer for sale on our website
            </li>
            <li>
              “Content” means information in any form published on our website
              by us or any third party with our consent.
            </li>
          </ul>
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          2. Our contract with you
        </Typography>
        <Typography>
          2.1 These terms and conditions apply:
          <br />
          2.1.1 so far as the context allows, to you as a visitor to our
          website; and
          <br />
          2.1.2 in any event to you as a buyer or prospective buyer of our
          Goods.
          <br />
          2.2 Goods advertised may not be available.
          <br />
          2.3 We shall accept your order by e-mail confirmation. Our message
          will also confirm details of your purchase and tell you when we shall
          despatch your order. That is when our contract is made. It is possible
          that the price may have increased from that posted on our website.
          <br />
          2.4 We may change these terms from time to time. The terms that apply
          to you are those posted here on our website on the day you order
          Goods.
          <br />
          2.5 All descriptions, weights and sizes of Goods are those of the
          original artist and you may not rely on their accuracy. Accordingly,
          any such description shall not form part of this Agreement.
          <br />
          2.6 If the Goods you order are not available, we will offer you
          alternatives before we despatch your order. If this happens you may:
          <br />
          2.6.1 accept the alternatives we offer;
          <br />
          2.6.2 cancel your order;
          <br />
          2.6.3 leave the order valid, but tell us to omit the out-of-stock
          item.
          <br />
          2.7 If we owe you money (for this or any other reason), we will credit
          your credit or debit card as soon as reasonably practicable (we aim to
          transfer this within 5 working days) but in any event no later than 30
          days from the date of your order.
          <br />
          2.8 Your contract is with us, not our artists. You may not under any
          circumstances correspond with or communicate with our artists
          regarding sales of Goods, returns, commissions or refunds. <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          3. Price and Payment
        </Typography>
        <Typography>
          3.1 You must pay us the full price of your order before we will send
          any part of it.
          <br />
          3.2 Banking charges by the receiving bank on payments to us will be
          borne by us. All other charges relating to payment in a currency other
          than pounds Sterling will be borne by you.
          <br />
          3.3 Any details given by us in relation to exchange rates are
          approximate only and may vary from time to time.
          <br />
          3.4 You will pay all sums due to us under these terms by the means
          specified without any set-off, deduction or counterclaim. <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          4. Information you give us
        </Typography>
        <Typography>
          4.1 You agree that you have provided, and will continue to provide
          accurate, up to date, and complete information about yourself. We need
          this information to provide you with the Goods. <br />
          4.2 We will use our reasonable endeavours to respond to any point of
          dissatisfaction by you, provided you contact us within 14 days of
          purchase. ​<br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          5. Delivery
        </Typography>
        <Typography>
          5.1 Deliveries will be made by the Carrier to the address stipulated
          in your order. You must ensure that someone is present to accept
          delivery.
          <br />
          5.2 If we are not able to deliver your Goods within 30 days of the
          date of your order, we shall notify you by e-mail to arrange another
          date for delivery.
          <br />
          5.3 We may deliver the goods in instalments if the goods are not
          available at the same time for delivery.
          <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          6. Orders from outside the UK and Ireland
        </Typography>
        <Typography>
          6.1 We will endeavour to arrange delivery to countries outside the UK.
          <br />
          6.2 Prices for delivery prices may already be quoted online but
          enquiries for delivery quotes can be made to us.
          <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          7. Returns and refunds
        </Typography>
        <Typography>
          Because you are buying the Goods by mail order, you may have a right
          of cancellation. If you do, (and only if you do), these are the terms
          which apply:
          <br />
          7.1 All correspondence regarding the return of Goods shall be carried
          out between You and us. You may not contact any artist directly for
          any reason.
          <br />
          7.2 You must tell us you wish to cancel within 14 days of your receipt
          of the Goods
          <br />
          7.3 The Goods must be returned to us within 21 days of delivery:
          <br />
          7.3.1 with both goods and all packaging in their original condition;
          <br />
          7.3.2 securely wrapped;
          <br />
          7.3.3 including our delivery slip;
          <br />
          7.3.4 at your risk and cost.
          <br />
          7.4 After we has received the Goods, we will credit your credit or
          debit card with the purchase price minus our admission fee returned no
          later than 30 days from the date of receipt;
          <br />
          7.5 If you do not return the Goods to us, you are still liable to us
          for the cost.
          <br />
          7.6 We are under no obligation to collect or recover Goods from you,
          but if we do, our costs will be payable by you.
          <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          8. Disclaimers
        </Typography>
        <Typography>
          8.1 We or our Content suppliers may make improvements or changes to
          our website, the Content, or to any of the Goods, at any time and
          without advance notice.
          <br />
          8.2 You are advised that Content may include technical inaccuracies or
          typographical errors.
          <br />
          8.3 We give no warranty and make no representation, express or
          implied, as to:
          <br />
          8.3.1 the adequacy or appropriateness of the Goods for your purpose.
          <br />
          8.3.2 the truth of any information given on our website;
          <br />
          8.3.3 any implied warranty or condition as to merchantability or
          fitness of the Goods and Services for a particular purpose;
          <br />
          8.3.4 compatibility of our website with your equipment software or
          telecommunications connection.
          <br />
          8.3.5 compliance with any law;
          <br />
          8.3.6 non-infringement of any right.
          <br />
          8.4 our website contains links to other Internet web sites. We have
          neither power nor control over any such website. You acknowledge and
          agree that we shall not be liable in any way for the Content of any
          such linked web site, nor for any loss or damage arising from your use
          of any such web site.
          <br />
          8.5 We are not liable in any circumstances for special, indirect or
          consequential loss or any damages whatsoever resulting from loss of
          use, loss of data or loss of revenues or profits, whether in an action
          of contract, negligence or otherwise, arising out of or in connection
          with your use of our website or the purchase of Goods.
          <br />
          8.6 In any claim against us our liability is limited to the value of
          the goods you have purchased in the contract which is the subject of
          the dispute.
          <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          9. Content and Intellectual Property Rights
        </Typography>
        <Typography>
          9.1 Title, ownership rights, and intellectual property rights in the
          Content whether provided by us or by any other Content provider shall
          remain the sole property of us and / or the other Content provider. We
          will strongly protect its rights in all countries.
          <br />
          9.2 You may not copy, modify, publish, transmit, transfer or sell,
          reproduce, create derivative works from, distribute, perform, display,
          or in any way exploit any of the Content, in whole or in part, except
          as is expressly permitted in this agreement.
          <br />
          9.3 You may download or copy the Content only for your own personal
          use, provided that you maintain all copyright and other notices
          contained in such Content. You may not store electronically any
          significant portion of any Content.
          <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          10. System Security
        </Typography>
        <Typography>
          10.1 You agree that you will not, and will not allow any other person
          to, violate or attempt to violate any aspect of the security of the
          Installation;
          <br />
          10.2 you agree that you will in no way modify, reverse engineer,
          disassemble, decompile, copy, or cause damage or unintended effect to
          any portion of our website, or any software used on our website, and
          that you will not permit any other person to do so.
          <br />
          10.3 You understand that any such violation is unlawful in many
          jurisdictions and that any contravention of law may result in criminal
          prosecution.
          <br />
          10.4 Examples of violations are:
          <br />
          10.4.1 accessing data unlawfully or without consent;
          <br />
          10.4.2 attempting to probe, scan or test the vulnerability of a system
          or network or to breach security or authentication measures;
          <br />
          10.4.3 attempting to interfere with service to any user, host or
          network, including, without limitation, via means of overloading,
          “flooding”, “mail bombing” or “crashing”;
          <br />
          10.4.4 forging any header or any part of the header information in any
          e-mail or newsgroup posting;
          <br />
          10.4.5 taking any action in order to obtain Goods to which you are not
          entitled.
          <br />
          10.5 You agree to indemnify us against any claim or demand, including
          reasonable lawyers’ fees, made by any third party due to or arising
          out of:
          <br />
          10.5.1 any violation of system security as set out above;
          <br />
          10.5.2 your use of our website;
          <br />
          10.5.3 any other breach or violation of this agreement by you;
          <br />
          10.5.4 the infringement by you, or by any other user of your computer,
          of any intellectual property or other right of any person or entity,
          or as a result of any threatening, libellous, obscene, harassing or
          offensive material contained in any of your communications.
          <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          11. Indemnity
        </Typography>
        <Typography>
          You agree to indemnify us against any claim or demand, including
          reasonable lawyers’ fees, made by any third party due to or arising in
          any way out of your use of our website, or the infringement by you, or
          by any other person using your computer, of any intellectual property
          or other right of any person. <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          12. Contractual Limitation
        </Typography>
        <Typography>
          Where we provide Goods without specific charge, then it (or they) is
          deemed to be provided free of charge, and not to be associated with
          any other service for which a charge is made. Accordingly, there is no
          contractual nor other obligation upon us in respect of any such goods.
          ​ <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          13. Rights of third parties
        </Typography>
        <Typography>
          Nothing in this agreement or on our website shall confer on any third
          party any benefit under the provisions of the Contracts (Rights of
          Third Parties) Act 1999. ​ <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          14. Severability
        </Typography>
        <Typography>
          If any of these terms is at any time held by any jurisdiction to be
          void, invalid or unenforceable, then it shall be treated as changed or
          reduced, only to the extent minimally necessary to bring it within the
          laws of that jurisdiction and to prevent it from being void and it
          shall be binding in that changed or reduced form. Subject to that,
          each provision shall be interpreted as severable and shall not in any
          way affect any other of these terms.
          <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          15. No Waiver
        </Typography>
        <Typography>
          No waiver by us, in exercising any right, power or provision hereunder
          shall operate as a waiver of any other right or of that same right at
          a future time; nor shall any delay in exercise of any power or right
          be interpreted as a waiver.  <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          16. Dispute Resolution
        </Typography>
        <Typography>
          In the event of a dispute arising out of or in connection with these
          terms or any contract between you and us, then you agree to attempt to
          settle the dispute by engaging in good faith with us in a process of
          mediation before commencing arbitration or litigation.
          <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          17. Force majeure
        </Typography>
        <Typography>
          We are not liable for any breach of our obligations resulting from
          causes beyond our reasonable control including strikes of our own
          employees.  <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          18. Governing Law
        </Typography>
        <Typography>
          This Agreement shall be governed by and construed in accordance with
          the law of England. This agreement shall not be governed by the United
          Nations Convention on Contracts for the International Sale of Goods,
          the application of which is hereby expressly excluded.
          <br /> <br />
        </Typography>
      </Container>
    </Fragment>
  );
};

export default TermsConditions;
